import React from "react";
import styled from "styled-components";
import { Container } from "../layout/Container";
import { HeaderSection } from "../layout/CardsContainer";
import LegalContentDisplay from "../components/LegalContentDisplay";
import bg from "../img/illustrations/background.png";
import useTranslation from "../hooks/useTranslation";

const MentionsLegales = () => {
  const { t } = useTranslation();
  return (
    <Page>
      <StyledContainer>
        <HeaderSection title={t('legal.mentions')} />
        <LegalContentDisplay type="mentions-legales" />
      </StyledContainer>
    </Page>
  );
};

export default MentionsLegales;

const Page = styled.div`
  padding-top: 4rem;
  min-height: 100vh;
  background-image: url(${bg});
  background-size: cover;
  background-attachment: fixed;
`;

const StyledContainer = styled(Container)`
  width: 70%;
  margin: 2rem auto;
  padding: 2rem;
  padding-bottom: 3rem;
  background-color: ${({ theme }) => theme.color.background};
  border-radius: 16px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  @media (max-width: 768px) {
    width: 95%;
    margin: 1rem auto;
    padding: 1.5rem;
    border-radius: 12px;
  }
`;

